// The setup page's API requests table, re-homed under the WiseAPI license view. Every
// api_requests row is written by the V1 controller against a wise_api configuration, so
// the organization-wide table already IS this partner's request log - only the header
// changes, to match the sibling tabs of this view.
WiseMetering.Views.WiseApiRequestsTable = WiseMetering.Views.IndexApiRequests.extend({
    icon: 'integrations',
    name: () => 'wise_api'
});
